import React from 'react';

import styles from './StyledDropdown.module.scss';
export const StyledContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['styled-container']} ${className}` : styles['styled-container']
    }
    {...props}
  />
);

/**
 * `data-line` is a deliberate, stable hook. Table cells in styled-strips and
 * styled-shared-table need to reach this element, and it is rendered by
 * InlineDropDown rather than by those modules, so they cannot pass it a class.
 * CSS Modules hashes class names, so an attribute is the only stable contract.
 */
export const StyledLine = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    data-line=""
    className={className ? `${styles['styled-line']} ${className}` : styles['styled-line']}
    {...props}
  />
);

export const StyledEmpty = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['styled-empty']} ${className}` : styles['styled-empty']}
    {...props}
  />
);

export const DescriptiveOptionLabel = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className
        ? `${styles['descriptive-option-label']} ${className}`
        : styles['descriptive-option-label']
    }
    {...props}
  />
);

export const DescriptiveOptionDescription = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className
        ? `${styles['descriptive-option-description']} ${className}`
        : styles['descriptive-option-description']
    }
    {...props}
  />
);

export const DescriptiveControl = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['descriptive-control']} ${className}` : styles['descriptive-control']
    }
    {...props}
  />
);

export const OptionsList = ({ className, ...props }: React.ComponentPropsWithoutRef<'ul'>) => (
  <ul
    className={className ? `${styles['options-list']} ${className}` : styles['options-list']}
    {...props}
  />
);
